import { render, staticRenderFns } from "./BookingTransferItem.vue?vue&type=template&id=35e40650&scoped=true&"
import script from "./BookingTransferItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./BookingTransferItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BookingTransferItem.vue?vue&type=style&index=0&id=35e40650&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e40650",
  null
  
)

export default component.exports